"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_dom_1 = require("react-dom");
const react_focus_lock_1 = __importDefault(require("react-focus-lock"));
const styled = __importStar(require("./styled"));
const Modal = ({ children, querySelector = '#epi-page-container', alwaysOnScreen, isModalOpen }) => {
    const domSafe = typeof document !== 'undefined';
    return domSafe
        ? (0, react_dom_1.createPortal)(react_1.default.createElement(react_focus_lock_1.default, { autoFocus: false },
            react_1.default.createElement(styled.ModalContainer, { tabIndex: -1, "aria-modal": "true", role: "dialog", alwaysOnScreen: alwaysOnScreen, isModalOpen: isModalOpen }, children)), document.querySelector(querySelector) || document.body)
        : null;
};
exports.default = Modal;
